module.exports = __webpack_public_path__ + "img/hero_um.58216a79.jpg";